import { createAsyncThunk } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';

import type { LiveProgram } from '../../../models';
import { FuelEntityType, FuelPortalService } from '../../../services';
import { IngestService } from '../../../services/ingest-service';
import type { RootState } from '..';
import { SetSnackbarMessage } from '../application-data';
import { UpdateForm } from '../live-program-editor';
import { SaveAssetJob } from './SaveAssetJob';
import type { StartJobPayload } from './SaveAssetJobsState';
import { removeJob, updateJob } from './SaveAssetJobsState';
import { uploadFile } from './uploadFile';

export const processSaveLiveProgramThumbnailJob = createAsyncThunk(
  'saveAssetJobs/processSaveLiveProgramThumbnailJob',
  async (payload: StartJobPayload, { dispatch, getState }) => {
    const { form, jobType, extraParams } = payload;
    const state = getState() as RootState;
    const job = new SaveAssetJob(form, jobType, extraParams);
    const { id } = form;
    let uploadUrls = null;

    const updateMessage = (message: string) => {
      // console.log('message', message);
      job.message = message;
      dispatch(updateJob(job));
    };

    const getUrl = (uploadUrls: any) => {
      const url = '';
      if (jobType === 'LiveProgramThumbnail') {
        return uploadUrls.entityUploadUrl;
      }
      return url;
    };

    const getExtension = (str) => str.substr(str.lastIndexOf('.') + 1);

    const getExtensionText = () => {
      if (jobType === 'LiveProgramThumbnail') {
        return 'thumbnailext';
      }
      return null;
    };
    let extension = null;
    const extensionText = getExtensionText();
    const file = job.liveProgramForm.ingestFile;
    if (file) {
      extension = getExtension(file.name);
    }
    job.progress = 0;
    try {
      updateMessage(`Preparing for upload...`);
      uploadUrls = await IngestService.getUploadUrl(id, FuelEntityType.LiveProgram, extensionText, extension);
      updateMessage(`Uploading file...`);
      const url = getUrl(uploadUrls);
      await uploadFile(file, url, (progress) => {
        job.progress = progress;
      });
    } catch (err) {
      updateMessage(`There was an error uploading file.`);
      throw err;
    }
    let lp = await FuelPortalService.getEntityById(FuelEntityType.LiveProgram, id, { fullInfo: true });
    if (lp && lp.metadata && uploadUrls && jobType === 'LiveProgramThumbnail') {
      // asset.data.externalSubtitles = externalSubtitles;
      lp.metadata.thumbnail = {
        s3Path: uploadUrls.entityUploadPath,
        publicUrl: null,
        previewUri: null,
      };
      updateMessage(`Updating liveprogram...`);
      // Updating asset with allowRestricted true for only thumbnail
      lp = await FuelPortalService.upsertEntity(FuelEntityType.LiveProgram, lp as LiveProgram);
      const newliveProgramForm = cloneDeep(form);
      if (lp && lp.metadata && lp.metadata.thumbnail && lp.metadata.thumbnail.previewUri) {
        newliveProgramForm.thumbnailSrc = lp.metadata.thumbnail.previewUri;
      }
      dispatch(UpdateForm(newliveProgramForm));
    }

    clearInterval(job.intervalId);
    job.progress = 100;
    job.jobStatus = 'Completed';
    dispatch(updateJob(job));
    dispatch(removeJob(job));
    dispatch(
      SetSnackbarMessage({
        message: 'File successfully uploaded.',
        severity: 'success',
      })
    );
    return true;
  }
);
